/* eslint-disable @typescript-eslint/no-var-requires */
import { Command } from 'commander';
import path from 'path';

const program = new Command();

program
  .name('pod-workflow')
  .description('A modern way to progressively update your code to the best practices using lint rules')
  .version(require(path.join(__dirname, '../', 'package.json')).version);

program
  .command('upgrade')
  .description('Upgrades a given pod path with codemods, linting, LTTF, and more.')
  .option('-b, --base-dir', 'parent pod directory', 'app/pods')
  .option('-p, --pod-dir', 'Directory for pod to be upgraded: skips file tree prompt', undefined)
  .action(async () => {
    console.log('upgrader');
  });

program.command('pr-description').action(async () => {
  console.log('FALALALA');
});

program.parse();
